export const TANK_TYPES = Object.freeze({
  CARGO: "cargo",
  BALLAST: "ballast",
  SLOP: "slop",
  OTHER: "other",
});

export const isTankType = (value) => Object.values(TANK_TYPES).includes(value);
